var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowBottomBlackR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 7,
  viewBox: "0 0 12 7",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.4996 0.551145C10.7815 0.25218 11.2569 0.252292 11.5387 0.551389C11.7978 0.826415 11.7977 1.25568 11.5386 1.53063L6.65505 6.71157C6.56941 6.80297 6.46756 6.87552 6.35538 6.92502C6.2432 6.97452 6.12289 7 6.00139 7C5.87988 7 5.75958 6.97452 5.6474 6.92502C5.53521 6.87552 5.43337 6.80297 5.34773 6.71157L0.461659 1.5306C0.202427 1.25572 0.202409 0.826415 0.461617 0.551515C0.743254 0.252828 1.21822 0.252806 1.49988 0.551467L6 5.32314L10.4996 0.551145Z",
  fill: "#171717"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowBottomBlackR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-bottom-black-r.1604db64ea4c74ddc03b744b2b396b05.svg";